module.exports = __webpack_public_path__ + "static/gallery-2-2d2ac052acde19270269e1f615baa5c3.jpg";